import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Button from "@mui/material/Button";
import { FaDownload } from "react-icons/fa";

const GenerateReportData = ({ excelData, fileName }) => {

  if (!excelData) {
    console.error("Excel data is null or undefined.");
    return null; // Or return an error message or placeholder component
  }

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";
  const wscols = [
    { wch: 15 },
    { wch: 50 },
    { wch: 75 },
    { wch: 20 },
    { wch: 75 },
  ];

  const addStyles = (workSheet) => {
    // Your style modifications here...
  };

  const exportTOExcel = async () => {
    const transformedData = transformData(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const range = XLSX.utils.decode_range(ws['!ref']);
    ws['!autofilter'] = { ref: XLSX.utils.encode_range(range) };
    addStyles(ws);
    ws['!cols'] = wscols;
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const exelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([exelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const transformData = (excelData) => {
    let newArray = [];
    for (const categoryKey in excelData) {
      if (Object.hasOwnProperty.call(excelData, categoryKey)) {
        const category = excelData[categoryKey];
        category.forEach(email => {
          newArray.push({
            ReportName: categoryKey,
            Email: email
          });
        });
      }
    }
    return newArray;
  };

  return (
    <div>
      {/* <Button
        variant="contained"
        onClick={(e) => exportTOExcel(fileName)}
        startIcon={<FaDownload />}
      >
        Export Excel
      </Button> */}

      <button
        style={{fontSize: "14px", padding: "12px",border:"none",width:"50px",borderRadius:"6px"}}
        onClick={(e) => exportTOExcel(fileName)}
        title="Export in excel"
      >
        <FaDownload/>
      </button>
    </div>
  );
};

export default GenerateReportData;
